module.exports = __webpack_public_path__ + "files/1747d03a3817d4dabfa577cdf2082e45.png";